import { TrustGroupType } from "@/models/enum/trustGroupType";
import { CompanyDto } from "@/models/dto/companyDto";

export class TrustGroupDto {
  id: string = "";
  company: CompanyDto = new CompanyDto();
  userProfileEmails: Array<string> = new Array<string>();
  trustGroupType: TrustGroupType = TrustGroupType.Channel2Customer;
}
